import { CrudEndpoint } from './crud.endpoint';

export class InventoryEndpoint extends CrudEndpoint {
	constructor() {
		super('inventory');
	}
}
